module.exports = __webpack_public_path__ + "static/media/orange.31f7bc83.png";